import React from "react";
import walletIcon from "../assets/icons8-wallet-24.png";
import { formatCurrency } from '../utils/currencyFormatter';

const SpendingWallet = ({ totalExpenses }) => {
  return (
    <div
    className="bg-white p-3 mb-0 d-flex justify-content-between align-items-center position-relative "
              style={{
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                marginTop: "-60px",
                borderRadius: "20px",
                marginRight: "10px",
                marginLeft: "10px"
              }}
            >
      <div className="d-flex align-items-center">
        <img
          src={walletIcon}
          alt="Wallet Icon"
          style={{ width: "24px", height: "24px", marginRight: "8px" }}
        />
        <span className="fw-bold">Spending Wallet</span>
      </div>
      <div className="d-flex align-items-center">
        <h6 className="mb-0 text-dark">{formatCurrency(totalExpenses)}</h6>
      </div>
    </div>
  );
};

export default SpendingWallet;


